/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Magnified_Download_TitleInputs */

const en_image_export_magnified_download_title = /** @type {(inputs: Image_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Preview`)
};

const fr_image_export_magnified_download_title = /** @type {(inputs: Image_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telecharger la previsualisation`)
};

const de_image_export_magnified_download_title = /** @type {(inputs: Image_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau herunterladen`)
};

const it_image_export_magnified_download_title = /** @type {(inputs: Image_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica l'anteprima`)
};

const ru_image_export_magnified_download_title = /** @type {(inputs: Image_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр загрузки`)
};

const es_image_export_magnified_download_title = /** @type {(inputs: Image_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar vista previa`)
};

const zh_cn2_image_export_magnified_download_title = /** @type {(inputs: Image_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载预览`)
};

const ja_image_export_magnified_download_title = /** @type {(inputs: Image_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューをダウンロード`)
};

const hi_image_export_magnified_download_title = /** @type {(inputs: Image_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन डाउनलोड करें`)
};

const pt_pt2_image_export_magnified_download_title = /** @type {(inputs: Image_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixar pré-visualização`)
};

/**
* | output |
* | --- |
* | "Download Preview" |
*
* @param {Image_Export_Magnified_Download_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_magnified_download_title = /** @type {((inputs?: Image_Export_Magnified_Download_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Magnified_Download_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_magnified_download_title(inputs)
	if (locale === "de") return de_image_export_magnified_download_title(inputs)
	if (locale === "it") return it_image_export_magnified_download_title(inputs)
	if (locale === "ru") return ru_image_export_magnified_download_title(inputs)
	if (locale === "es") return es_image_export_magnified_download_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_magnified_download_title(inputs)
	if (locale === "ja") return ja_image_export_magnified_download_title(inputs)
	if (locale === "hi") return hi_image_export_magnified_download_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_magnified_download_title(inputs)
	return en_image_export_magnified_download_title(inputs)
});